import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions, connectFunctionsEmulator, Functions } from 'firebase/functions';

// Validate required environment variables
const requiredEnvVars = [
  'REACT_APP_FIREBASE_API_KEY',
  'REACT_APP_FIREBASE_AUTH_DOMAIN', 
  'REACT_APP_FIREBASE_PROJECT_ID',
  'REACT_APP_FIREBASE_STORAGE_BUCKET',
  'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
  'REACT_APP_FIREBASE_APP_ID'
];

for (const envVar of requiredEnvVars) {
  if (!process.env[envVar]) {
    throw new Error(`Missing required environment variable: ${envVar}`);
  }
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY!,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN!,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID!,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET!,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID!,
  appId: process.env.REACT_APP_FIREBASE_APP_ID!
};
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Create a completely fresh Functions instance with error handling
let functions: Functions;
try {
  functions = getFunctions(app, 'us-central1');
} catch (error) {
  console.error('Error initializing Firebase Functions:', error);
  // Fallback: try without region
  functions = getFunctions(app);
}
export { functions };

// Development mode: Use emulator if available
// console.log('🔥 Firebase Functions Configuration:');
if (functions && functions.app && functions.app.options) {
  console.log('🔥 Project:', functions.app.options.projectId);
  // console.log('- Region:', 'us-central1');
}

// Connect to emulator in development
if (process.env.NODE_ENV === 'development') {
  try {
    connectFunctionsEmulator(functions, 'localhost', 5001);
    // console.log('🚀 Connected to Firebase Functions Emulator on localhost:5001');
  } catch (error) {
    console.log('⚠️ Could not connect to emulator, using production:', error);
  }
} else {
  console.log('✅ Using production Firebase Functions');
}